import React, {
  createContext,
  useContext,
  useState,
  useCallback,
  ReactNode,
} from "react";

export interface HeaderActionConfig {
  id: string;
  component: ReactNode;
}

interface HeaderActionsContextType {
  actions: HeaderActionConfig[];
  setActions: (actions: HeaderActionConfig[]) => void;
  clearActions: () => void;
}

const HeaderActionsContext = createContext<
  HeaderActionsContextType | undefined
>(undefined);

export const HeaderActionsProvider: React.FC<{ children: ReactNode }> = ({
  children,
}) => {
  const [actions, setActions] = useState<HeaderActionConfig[]>([]);

  const clearActions = useCallback(() => {
    setActions([]);
  }, []);

  const setActionsMemoized = useCallback((newActions: HeaderActionConfig[]) => {
    setActions(newActions);
  }, []);

  return (
    <HeaderActionsContext.Provider
      value={{ actions, setActions: setActionsMemoized, clearActions }}
    >
      {children}
    </HeaderActionsContext.Provider>
  );
};

export const useHeaderActions = () => {
  const context = useContext(HeaderActionsContext);
  if (!context) {
    throw new Error(
      "useHeaderActions must be used within a HeaderActionsProvider",
    );
  }
  return context;
};
